// src/components/Chatbot.js
import React, { useState } from 'react';
import axios from 'axios';
import Styles from '../Styles/ChatGbt.module.css';

const Chatbot = () => {
  const [input, setInput] = useState('');
  const [chat, setChat] = useState([]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const newChat = [...chat, { role: 'user', content: input }];
    setChat(newChat);
    setInput('');

    try {
      const response = await axios.post('http://localhost:5000/ChatGbt', {
        message: input,
      });

      setChat([...newChat, { role: 'bot', content: response.data.reply }]);
    } catch (err) {
      console.error('Error:', err);
      setChat([...newChat, { role: 'bot', content: 'Error getting response' }]);
    }
  };

  return (
    <div className={Styles.maincontainer}>
      <h2>Gemini AI Assistant 🤖</h2>
      <div>
        {chat.map((msg, idx) => (
          <div key={idx} style={{ 
            textAlign: msg.role === 'user' ? 'right' : 'left', 
            float: msg.role === 'user' ? 'right' : 'left', 
            background:'#a7a7a71a',
            width:"80%",
            border:'2px solid black',
            borderRadius:'5px',
            padding:'10px 15px',
            marginTop:'15px'
            }}>
            <b>{msg.role === 'user' ? 'You' : 'Bot'}:</b>
            {msg.content.split('\n').map((line, i) => (
            <div key={i}>{line}</div>
            ))}
          </div>
        ))}
      </div>

      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Ask Suggestion on your Resume"
        style={{ width: '80%', padding: '10px' }}
      />
      <button onClick={sendMessage} className={Styles.chat_btn}>
        Send
      </button>
    </div>
  );
};

export default Chatbot;
